import { ChevronDownIcon } from '@heroicons/react/20/solid';
import * as Popover from '@radix-ui/react-popover';
import React from 'react';

import { PopoverContent } from './Animations';
import { cn } from './cn';

export interface SelectOption {
  key: string;
  text: string;
}

export interface SelectProps {
  placeholder?: string;
  options: SelectOption[];
  onSelect?: (option: SelectOption) => void;
  renderItem?: (option: SelectOption) => React.ReactNode;
  className?: string;
  maxWidth?: number;
}

export const Select = ({ placeholder, options, onSelect, renderItem, className, maxWidth }: SelectProps) => {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button
          className={cn(
            'inline-flex items-center gap-1 rounded-md border-none bg-transparent px-0 py-1 text-xs text-gray-600 hover:text-info-500 transition-colors duration-200 cursor-pointer',
            className
          )}
          style={maxWidth ? { maxWidth } : undefined}
        >
          <span className="truncate">{placeholder}</span>
          <ChevronDownIcon className="h-3.5 w-3.5 shrink-0" />
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          className="z-50 min-w-[200px] max-w-[220px] rounded-lg border border-border bg-surface py-1 shadow-lg"
          sideOffset={4}
          align="start"
          asChild
        >
          <PopoverContent>
            {options.map((option) =>
              renderItem ? (
                <div key={option.key}>{renderItem(option)}</div>
              ) : (
                <button
                  key={option.key}
                  className="flex w-full items-center gap-2 px-3 py-2 text-left text-xs text-gray-700 hover:bg-gray-50 hover:text-info-500 transition-colors duration-150 cursor-pointer bg-transparent border-none"
                  onClick={() => onSelect?.(option)}
                >
                  <span className="truncate">{option.text}</span>
                </button>
              )
            )}
          </PopoverContent>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
